import { render, staticRenderFns } from "./WorkGroupShow.vue?vue&type=template&id=4ba5ed68&"
import script from "./WorkGroupShow.vue?vue&type=script&lang=js&"
export * from "./WorkGroupShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports